module.exports = __webpack_public_path__ + "media/images/tl/banner/vi-2-dark-b8a002cc8f97a691e7fd6abdce9df6b8.jpg";